import React, { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../../GlobalContext'
import { getDate } from '../../utils/getDate'
import { Link } from 'react-router-dom'


type Props = {
    thisReminder: ObjectStringKeyAnyValue

}

function ChecklistReminderAlert({
    thisReminder
}: Props) {

    const {
        tableData,
    } = useContext(GlobalContext)


    const thisChecklistId = thisReminder['ChecklistId']
    const thisChecklist = tableData && tableData['Checklists'] && tableData['Checklists'][thisChecklistId] || {}
    const checklistName = thisChecklist['ChecklistName'] || 'Unknown checklist'
    const readableNextDueDate = thisReminder['nextDueTimeStamp'] && getDate(thisReminder['nextDueTimeStamp'], 'formattedDate') || ''
    const reminderStatus = thisReminder['reminderStatus'] || ''

    return <Link to={`/start-checklist/${thisChecklistId}`}><div
        className={`
       bg-white text-sm text-black w-full flex flex-row items-center gap-2 px-2 py-2 rounded hover:opacity-80 cursor-pointer`}

    >
        {reminderStatus === 'overdue' && <div className={`text-4xl`}>🚨</div>}
        {reminderStatus === 'showReminder' && <div className={`text-4xl`}>⏰</div>}
        {reminderStatus !== 'showReminder' && reminderStatus !== 'overdue' && <div className={`text-4xl`}>📆</div>}

        <div className={`flex flex-col justify-between items-start gap-1`}>
            <div className={`w-full flex flex-col`}>
                <p className={``}>{checklistName}</p>
                <p className={`text-xs text-gray-700`}>

                    Due by {readableNextDueDate}
                    {reminderStatus === 'overdue' && <span className={`text-sm text-red-600 font-semibold pl-1`}>(overdue)</span>}
                </p>

            </div>
        </div>
    </div></Link>
}
export default ChecklistReminderAlert